import ApiService from '@/services/ApiService'

const REPOSITORY_URL = 'resumen'

const ResumenRepository = {
  resumenCostoAgricultor(pIdEstablecimiento,pIdGrupoExplotacion, idTemporada) {
    let data = {
      pIdEstablecimiento,
      pIdGrupoExplotacion,
      idTemporada
    }
    return ApiService.get(`${REPOSITORY_URL}/resumen_costo_agricultor`, data)
  },

  resumenRendimientoFichaAgricola(pIdEstablecimiento, pIdGrupoExplotacion, idTemporada) {
    let data = {
      pIdEstablecimiento,
      pIdGrupoExplotacion,
      idTemporada
    }
    return ApiService.get(`${REPOSITORY_URL}/resumen_rendimiento_ficha_agricola`, data)
  },

  resumenRendimientoVariedad(pIdEstablecimiento, pIdGrupoExplotacion, idTemporada) {
    let data = {
      pIdEstablecimiento,
      pIdGrupoExplotacion,
      idTemporada
    }
    return ApiService.get(`${REPOSITORY_URL}/resumen_rendimiento_variedad`, data)
  },

  resumenAnalisisProduccionAnimal(idFichaGanadera){
    let data = {
      idFichaGanadera
    }
    return ApiService.get(`${REPOSITORY_URL}/resumen_analisis_produccion_animal`, data)
  },

  resumenCostosProduccionAnimal(idFichaGanadera){
    let data = {
      idFichaGanadera
    }
    return ApiService.get(`${REPOSITORY_URL}/costos_produccion_animal`, data)
  }
}

export default ResumenRepository
